<script>
import { authComputed } from "@state/helpers";
let _ = require("lodash");
// import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  // components: { VuePerfectScrollbar },
  props: {
    user: {
      type: Object,
      required: true,
      default: () => ({ is_superuser: false }),
    },
  },
  data() {
    return {
      date_actual:new Date().toDateString('es-ES'),
      block_Payment: JSON.parse(localStorage.getItem('auth.currentSession')).user.user_info.block_Payment,
      diff_payment_date: JSON.parse(localStorage.getItem('auth.currentSession')).user.user_info.diff_payment_date,
    };
  },
  computed: {
    ...authComputed,
    getCompanyInfo: function () {
      return this.$store.state.appAuth.companyInfo || null;
    },
    langSelected: {
      get() {
        return this.$store.state.language.language;
      },
      set(val) {
        this.$store.commit("language/SET_LANGUAGE", val);
      },
    },
    langFlagSelected: function () {
      return this.$store.state.language.languages.find(
        (x) => this.langSelected === x.value
      ).flag;
    },
    date_translate: function () { 
      const date_actual = new Date();
      const options = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' };
      const fecha_en_espanol = this.capitalizeFirstLetters(date_actual.toLocaleDateString('es-ES', options));
      return fecha_en_espanol

    },
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    capitalizeFirstLetters(string) {
      const words = string.split(' ');
      for (let i = 0; i < words.length; i++) {
          words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
      }
      return words.join(' ');
    }

  },
};
</script>

<template>
  <!-- Topbar Start -->
  <div class="navbar-custom">
    <ul class="list-unstyled topnav-menu float-right mb-0">
      <!-- Traduction options -->
      <b-nav-item-dropdown right class="notification-list" menu-class="language-dropdown">
        <template slot="button-content">
        </template>
      </b-nav-item-dropdown>

      <!-- User dropdown -->
      <b-nav-item-dropdown
        v-if="loggedIn"
        right
        class="notification-list user-drop"
        menu-class="profile-dropdown"
      >
        <template slot="button-content">
          <div class="nav-user mr-0 waves-effect waves-light">
            <img
              :src="
                currentSession.user.user_info && currentSession.user.user_info.photo
                  ? currentSession.user.user_info.photo
                  : require('@assets/images/users/avatar-clear.png')
              "
              alt="user-image"
              class="rounded-circle"
            />
            <i class="mdi mdi-chevron-down"></i>
          </div>
        </template>
        <b-dropdown-item disabled>
          <div class="row">
            <img
              :src="
                currentSession.user.user_info && currentSession.user.user_info.photo
                  ? currentSession.user.user_info.photo
                  : require('@assets/images/users/avatar-clear.png')
              "
              alt="user-image"
              class="rounded-circle"
              fluid
            />
          </div>
        </b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item href="/logout">
          <i class="fe-log-out mr-1"></i>
          <span>{{ $t("Logout") }}</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </ul>

    <!-- LOGO -->
    <div class="logo-box">
      <a href="/" class="logo text-center">
        <span class="logo-lg">
          <img
            style="vertical-align: middle; border-style: none"
            v-if="getCompanyInfo && getCompanyInfo.light_logo"
            :src="require('@assets/images/logos/logo-dark-medium.png')"
            alt=""
            height="120"
            class="p-1"
          />
          <!-- <span class="logo-lg-text-light">Xeria</span> -->
        </span>
        <span class="logo-sm d-md-none">
          <!-- <span class="logo-sm-text-dark">X</span> -->
          <img
            v-if="getCompanyInfo"
            :src="
              getCompanyInfo.short_dark_logo ||
              require('@assets/images/logos/logo-dark-short.png')
            "
            alt=""
            class="p-1"
            height="100"
          />
        </span>
      </a>
    </div>
    <ul
      class="list-unstyled topnav-menu topnav-menu-left m-0"
      :class="user.is_superuser ? 'd-block' : 'd-none d-sm-block'"
    >
      <li>
        <button class="button-menu-mobile waves-effect waves-light" @click="toggleMenu">
          <i class="fad fa-bars"></i>
        </button>
      </li>
    </ul>
    <div v-if="diff_payment_date>=1 && block_Payment" class="d-flex justify-content-center align-items-center mt-3"><b-alert class="col-9" show variant="primary"><a href="#" class="alert-link text-primary">Tu fecha límite de <b>Pago</b> ha caducado, no te preocupes tienes <b>{{5-diff_payment_date}}</b> día(s) para realizar el pago.</a></b-alert></div>
    
  </div>
  <!-- end Topbar -->
</template>

<style lang="scss">
.noti-scroll {
  height: 220px;
}
.ps > .ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 6px !important;
}
.button-menu-mobile {
  outline: none !important;
}
.user-drop {
  ul {
    min-width: 350px;
  }
  img {
    flex: auto;
    max-width: 45px;
    max-height: 45px;
    margin-right: 8px;
  }
  .user-label {
    flex: 0 0 70%;
    max-width: 70%;
  }
}
</style>
